/**
 * Created by andrey on 20.05.2025
 */
import CleverAppsNative from "./cleverappsnative";
import Utils from "./utils";
import router from "../router";

const adUnits = {
    banner: "R-A-8148274-3",
    rewarded: {
        touch: "R-A-8148274-4",
        desktop: "R-A-8148274-5"
    },
    fullscreen: {
        touch: "R-A-8148274-1",
        desktop: "R-A-8148274-2"
    }
};

const AD_BANNER_WIDTH = 728;
const AD_BANNER_HEIGHT = 90;

const YandexAds = {
    connect: function (callback) {
        window.yaContextCb = window.yaContextCb || [];

        Utils.loadSdk("//yandex.ru/ads/system/context.js", {
            onSuccess: () => {
                callback(CleverAppsNative.CODE_SUCCEED);
            }
        });
    },

    play: function (options, callback) {
        const platform = Ya.Context.AdvManager.getPlatform();

        let type = options.name;
        if (type === "interstitial") {
            type = "fullscreen";
        }

        const blockId = adUnits[type][platform];

        window.yaContextCb.push(
            Ya.Context.AdvManager.render({
                blockId,
                type,
                platform,
                onRewarded: function (isRewarded) {
                    console.log(`playAd onRewarded - ${isRewarded}`);
                    callback(isRewarded ? CleverAppsNative.CODE_SUCCEED : "closed_by_user");
                },
                onError: function (data) {
                    console.log("playAd error: ", data.type);
                    callback(`${options.name}_unknown_error`);
                },
                onClose: function () {
                    console.log("playAd fullscreen closed");
                    callback(CleverAppsNative.CODE_SUCCEED);
                }
            }, () => {
                console.log(`no ${options.name} ad`);
                callback(`${options.name}_not_found`);
            })
        );
    },

    isStickyAvailable: function () {
        return window.innerWidth >= AD_BANNER_WIDTH;
    },

    showSticky: function (callback) {
        if (!this.isStickyAvailable()) {
            callback(CleverAppsNative.CODE_FAILED);
            return;
        }

        this.addBannerContainer();

        const showStickyCallback = (code) => {
            const params = code === CleverAppsNative.CODE_SUCCEED ? {
                width: AD_BANNER_WIDTH,
                height: AD_BANNER_HEIGHT
            } : {};
            
            callback(code, params);
            callback = function () {};
        };

        window.yaContextCb.push(() => {
            Ya.Context.AdvManager.render({
                blockId: adUnits.banner,
                renderTo: "yandex-ad-banner-container-ins",
                onRender: function () {
                    console.log("Banner ad started showing");
                    showStickyCallback(CleverAppsNative.CODE_SUCCEED);
                },
                onError: function (data) {
                    console.log("bannerAd error: ", data.type);
                    showStickyCallback("banner_unknown_error");
                }
            }, () => {
                console.log("No banner ad available");
                showStickyCallback("banner_not_found");
            });
        });
    },

    closeSticky: function (callback) {
        this.removeBannerContainer();

        callback(CleverAppsNative.CODE_SUCCEED);
    },

    addBannerContainer: function () {
        if (document.getElementById("yandex-ads-banner-container")) {
            return;
        }

        const container = document.createElement("div");
        container.id = "yandex-ads-banner-container";
        container.style.display = "block";
        container.style.position = "absolute";
        container.style.bottom = "0";
        container.style.margin = "0 auto";
        container.style.right = "0";
        container.style.left = "0";
        container.style.height = `${AD_BANNER_HEIGHT}px`;
        container.style.width = `${AD_BANNER_WIDTH}px`;
        container.style.zIndex = "2";
        container.style.backgroundColor = "white";

        const ins = document.createElement("ins");
        ins.id = "yandex-ad-banner-container-ins";
        ins.style.zIndex = "2";
        ins.style.display = "inline-block";
        ins.style.position = "relative";
        ins.style.margin = "0 auto";
        ins.style.height = `${AD_BANNER_HEIGHT}px`;
        ins.style.width = `${AD_BANNER_WIDTH}px`;

        document.body.appendChild(container);
        container.appendChild(ins);
    },

    removeBannerContainer: function () {
        const container = document.getElementById("yandex-ads-banner-container");
        if (container) {
            console.log("yandex ads removeBannerContainer");
            container.remove();
        }
    }
};

router.beforeEach((to, from, next) => {
    if (!to.path.startsWith("/play/")) {
        YandexAds.removeBannerContainer();
    }
    next();
});

export default {
    install: function () {
        CleverAppsNative.addPlugin("YandexAds", YandexAds);
    }
};